import { useSuspenseQuery } from '@tanstack/react-query';
import { useGraphneAPI, type ResponseError, type SimulationParameterView } from '@nexelem/graphne-api';

export const useSuspenseGetGraphneSimulationParameters = () => {
  const api = useGraphneAPI();

  return useSuspenseQuery({
    queryKey: ['gantt-simulation-params'],
    queryFn: () =>
      api.getGraphneSimulationParameters().catch((error: ResponseError) => {
        if (error?.response?.status === 404) {
          return [] as SimulationParameterView[];
        }
        throw error;
      }),
  });
};
